import moment from 'moment'
import Validate from './validate'

/**
 * 获取星期数
 * @param {*} date 【选填】日期，默认为当前时间。可为日期和时间戳
 * @return 返回传入日期的星期数
 */
function week (date = {}) {
  if (Validate.isUndeFinedOrNullOrBlank(date)) return date
  const weekEn = moment(date).format('dddd');
  const weekObj = {
    Sunday: '星期天',
    Monday: '星期一',
    Tuesday: '星期二',
    Wednesday: '星期三',
    Thursday: '星期四',
    Friday: '星期五',
    Saturday: '星期六'
  }
  return weekObj[weekEn]
}

/**
 * 获取周数
 * @param {*} date 【选填】日期，默认为当前时间。可为日期和时间戳
 */
function weekCount (date = {}) {
  if (Validate.isUndeFinedOrNullOrBlank(date)) return date
  return moment(date).isoWeek()
}

/**
 * 获取格式化时间等
 * @param {*} regexpStr 【选填】获取的时间格式，默认'YYYY-MM-DD HH:mm:ss'
 * @param {*} date 【选填】日期，默认为当前时间。可为日期和时间戳
 * @return 返回所要获取的时间格式/参数
 */
function time (regexpStr = 'YYYY-MM-DD HH:mm:ss', date = {}) {
  if (Validate.isUndeFinedOrNullOrBlank(date)) return date
  return moment(date).format(regexpStr);
}

/**
 * 获取时间间隔
 * @param {*} date1 【选填】默认当前时间
 * @param {*} date2 【选填】默认当前时间
 * @param {*} intervalFormat 【选填】间隔参数，默认返回间隔毫秒数
 *  example: days：间隔天数；hours：间隔小时数；minutes：间隔分钟数；seconds：间隔秒数；
 */
function timeInterval (date1 = {}, date2 = {}, intervalFormat = 'milliseconds') {
  return Math.abs(moment(date1).diff(moment(date2), intervalFormat)) 
}

export default {
  week,
  time,
  weekCount,
  timeInterval
}
